<div class="bg-color-base-2500 rdm-succes-wrapper h-100vh">
    <!-- Decorative motif: scattered confetti dots, stars, outlined gift boxes -->
    <div class="rdm-succes-motif" aria-hidden="true">
        <span class="motif-dot motif-dot-1"></span>
        <span class="motif-dot motif-dot-2"></span>
        <span class="motif-dot motif-dot-3"></span>
        <span class="motif-dot motif-dot-4"></span>
        <span class="motif-dot motif-dot-5"></span>
        <span class="motif-dot motif-dot-6"></span>
        <span class="motif-dot motif-dot-7"></span>
        <span class="motif-dot motif-dot-8"></span>
        <span class="motif-dot motif-dot-9"></span>
        <span class="motif-dot motif-dot-10"></span>
        <span class="motif-dot motif-dot-11"></span>
        <span class="motif-dot motif-dot-12"></span>
        <span class="motif-star motif-star-1">&#10038;</span>
        <span class="motif-star motif-star-2">&#10038;</span>
        <span class="motif-star motif-star-3">&#10038;</span>
        <span class="motif-star motif-star-4">&#10038;</span>
        <span class="motif-star motif-star-5">&#10038;</span>
        <span class="motif-gift motif-gift-1">&#127873;</span>
        <span class="motif-gift motif-gift-2">&#127873;</span>
        <span class="motif-gift motif-gift-3">&#127873;</span>
        <span class="motif-gift motif-gift-4">&#127873;</span>
        <span class="motif-confetti motif-confetti-1"></span>
        <span class="motif-confetti motif-confetti-2"></span>
        <span class="motif-confetti motif-confetti-3"></span>
        <span class="motif-confetti motif-confetti-4"></span>
        <span class="motif-confetti motif-confetti-5"></span>
    </div>

    <!-- Large circular white/cream center icon -->
    <div class="rdm-succes-circle rdm-succes-circle-lg">
        <ng-icon iconClass="icon-success-100px" width="140" height="140"></ng-icon>
    </div>

    <!-- Heading + subtext -->
    <grid-row class="justify-content-center">
        <grid-col col="12" class="text-align-center">
            <div class="rdm-succes-title" *ngIf="!isGiveBack; else giveBackTitle">
                {{ "RedemptionSuccessful" | translate }}
            </div>
            <ng-template #giveBackTitle>
                <div class="rdm-succes-title">
                    {{ "ThankYouForGivingBack" | translate }}
                </div>
            </ng-template>

            <div class="rdm-succes-sub" *ngIf="!isGiveBack">
                {{ "CongratulationsSub" | translate }}
            </div>
            <div class="rdm-succes-sub" *ngIf="isGiveBack">
                {{ "DonationReceivedSub" | translate }}
            </div>

            <!-- Status from API -->
            <div class="rdm-succes-status mt-10" *ngIf="redemptionStatus">
                {{ redemptionStatus }}
            </div>
        </grid-col>
    </grid-row>

    <!-- Receipt card -->
    <div class="rdm-receipt-card-wrapper">
        <div class="rdm-receipt-card" *ngIf="redeem.lastRedemptionResult as pr">
            <!-- Top row: partner logo + name/category -->
            <div class="rdm-receipt-row rdm-receipt-top">
                <div class="rdm-receipt-logo">
                    <img *ngIf="pr.imageUrl" [src]="pr.imageUrl" [alt]="pr.redeemType" />
                    <div *ngIf="!pr.imageUrl" class="rdm-receipt-logo-fallback">
                        {{ (pr.redeemType || '').charAt(0) }}
                    </div>
                </div>
                <div class="rdm-receipt-name">
                    <div class="rdm-receipt-name-line">
                        <span class="rdm-receipt-name-text">{{ pr.redeemType }}</span>
                        <span *ngIf="pr.category" class="rdm-receipt-name-sep">&middot;</span>
                        <span *ngIf="pr.category" class="rdm-receipt-name-cat">{{ pr.category }}</span>
                    </div>
                    <div class="rdm-receipt-name-sub">
                        {{ "RewardRedemption" | translate }}
                    </div>
                </div>
            </div>

            <!-- Redeem date -->
            <div class="rdm-receipt-row">
                <div class="rdm-receipt-label">{{ "RedeemDate" | translate }}</div>
                <div class="rdm-receipt-value">{{ redeemDate | date:'dd MMM yyyy' }}</div>
            </div>

            <!-- Reference -->
            <div class="rdm-receipt-row">
                <div class="rdm-receipt-label">{{ "Reference" | translate }}</div>
                <div class="rdm-receipt-value rdm-receipt-mono">{{ referenceNumber }}</div>
            </div>

            <!-- IMTIAZ points used -->
            <div class="rdm-receipt-row">
                <div class="rdm-receipt-label">{{ "IMTIAZPointsUsed" | translate }}</div>
                <div class="rdm-receipt-value">
                    {{ pr.selectedPoint | number }} pts
                </div>
            </div>

            <!-- Value -->
            <div class="rdm-receipt-row" *ngIf="hasValueRow()">
                <div class="rdm-receipt-label">{{ "Value" | translate }}</div>
                <div class="rdm-receipt-value rdm-receipt-value-green">
                    {{ getValueDisplay() }}
                </div>
            </div>

            <!-- Revised available points (from API) -->
            <div class="rdm-receipt-row" *ngIf="revisedAvailablePoints">
                <div class="rdm-receipt-label">{{ "Available Points" | translate }}</div>
                <div class="rdm-receipt-value">
                    {{ revisedAvailablePoints | number }} pts
                </div>
            </div>
        </div>
    </div>

    <!-- Action buttons -->
    <div class="rdm-succes-actions">
        <button class="rdm-btn rdm-btn-primary" (click)="Dashboard()">
            {{ "Done" | translate }}
        </button>
        <button
            class="rdm-btn rdm-btn-secondary"
            *ngIf="!isGiveBack"
            (click)="Dashboard()">
            {{ "ViewRewardDetails" | translate }}
        </button>
    </div>
</div>
